// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-card.selected {
  background-color: #f0f8ff;
}

mat-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

.badge {
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 0.85em;
  font-weight: 500;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-warning {
  background-color: #ffc107;
  color: #000;
}

.badge-danger {
  background-color: #dc3545;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/app/workflow-test-assignment/workflow-test-assignment.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":["mat-card.selected {\n  background-color: #f0f8ff;\n}\n\nmat-card:hover {\n  box-shadow: 0 4px 8px rgba(0,0,0,0.2);\n}\n\n.badge {\n  padding: 4px 8px;\n  border-radius: 3px;\n  font-size: 0.85em;\n  font-weight: 500;\n}\n\n.badge-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.badge-warning {\n  background-color: #ffc107;\n  color: #000;\n}\n\n.badge-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
